module.exports = __webpack_public_path__ + "img/26.495ada3f.jpg";